import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

const Guides = () => {
  return (
    <section id="guides" className="py-20 bg-regal-dark">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <BookOpen className="w-12 h-12 text-regal-red" />
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              Casino Guides
            </h2>
          </div>

          <div className="bg-regal-gray rounded-xl p-8 md:p-12 border border-gray-800">
            <h3 className="text-2xl font-bold text-white mb-4">
              How to Play Online Casinos in the UK
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Playing online casinos in the UK is straightforward, but understanding the essentials helps you make smarter choices. Start by choosing a licensed operator—look for UK Gambling Commission approval. Create your account, verify your identity (required by law), and claim your welcome bonus. Most casinos offer deposit matches or free spins to new players.
            </p>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Before you deposit, check the bonus terms: wagering requirements, game restrictions, and withdrawal limits. Set a budget and stick to it—responsible gaming means playing within your means. Use secure payment methods like debit cards, e-wallets, or bank transfers. When you're ready to cash out, verify your account is fully verified to avoid delays.
            </p>
            <p className="text-gray-300 mb-8 leading-relaxed">
              Explore different game types: slots for quick spins, table games for strategy, live dealers for authentic casino atmosphere. Always read game rules and RTP (Return to Player) percentages. Remember, gambling should be entertainment, not a way to make money. If you need support, visit BeGambleAware.org for free resources.
            </p>
            <Link
              to="/guides"
              data-discover="true"
              className="inline-flex items-center gap-2 bg-regal-red hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-all"
            >
              Read Full Guides
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guides;

